export function cmsUrl(
    path: string | null | undefined,
    baseUrl: string,
): string | undefined {
    if (!path) return undefined;
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    return `${baseUrl}${path}`;
}
